import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  message,
  Space,
  Popconfirm,
} from "antd";
import { PlusOutlined, DeleteOutlined, TeamOutlined } from "@ant-design/icons";
import "./index.css";
import httpUtil from "../../../../utils/httpUtil";

const { Column } = Table;

export const ClassManage = ({ userInfo }) => {
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isStudentModalVisible, setIsStudentModalVisible] = useState(false);
  const [currentClass, setCurrentClass] = useState(null);
  const [form] = Form.useForm();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchInput, setSearchInput] = useState("");

  //获取全部班级
  const getAllClass = () => {
    httpUtil.geAllClasses({ username: userInfo.username }).then((res) => {
      if (res.success) {
        setPagination({ current: 1, pageSize: 10 });
        setClasses(res.data);
      }
    });
  };

  useEffect(() => {
    getAllClass();
  }, []);

  // 添加班级
  const handleAddClass = async (values) => {
    try {
      const parmas = {
        username: userInfo.username,
        className: values.name, // 确保字段名与后端一致
      };

      // 调用接口
      httpUtil.addClasses(parmas).then((res) => {
        if (res.success) {
          // 成功后更新本地状态
          const newClass = {
            id: res.data.classId, // 使用后端返回的ID
            name: res.data.className,
            createdAt: res.data.createdAt, // 使用后端返回的时间
          };

          getAllClass();
          message.success("班级添加成功");
          setIsModalVisible(false);
          form.resetFields();
        } else {
          message.error(res.error || "添加班级失败");
        }
      });
    } catch (err) {
      console.error("添加班级错误:", err);
      message.error("请求失败，请稍后重试");
    }
  };

  // 删除班级
  const handleDeleteClass = (classId) => {
    const parmas = {
      username: userInfo.username,
      className: classId,
    };
    httpUtil.deleteClasses(parmas).then((res) => {
      if (res.success) {
        getAllClass();
        message.success("班级删除成功！");
      } else {
        message.error("班级删除失败！");
      }
    });
  };

  // 查看班级学生名单
  const getClassStudents = (className) => {
    const parmas = { classCode: className };
    setPagination({ ...pagination, current: 1 });
    httpUtil.getStudentsByClass(parmas).then((res) => {
      console.log(res);
      if (res.success) {
        setStudents(res.data);
        setCurrentClass(className);
        setIsStudentModalVisible(true);
      } else {
        message.error(res.error);
      }
    });
  };

  const handleSearch = async (searchInput) => {
    try {
      httpUtil.geAllClasses({ username: userInfo.username }).then((res) => {
        if (res.success) {
          const allClasses = Array.isArray(res.data) ? res.data : [];

          const foundClass = allClasses.find(
            (cls) =>
              String(cls.name).toLowerCase() ===
              String(searchInput).toLowerCase()
          );

          if (foundClass) {
            setClasses(allClasses.filter((cls) => cls.id === foundClass.id));
            message.success(`已找到班级: ${foundClass.name}`);
          } else {
            setClasses(allClasses);
            message.error(`未找到名称包含"${searchInput}"的班级`);
          }
        } else {
          message.error(res.error || "获取班级列表失败");
          setClasses([]);
        }
      });
    } catch (err) {
      console.error("搜索班级错误:", err);
      message.error("搜索时发生错误");
      setClasses([]);
    }
  };
  
    //重置
    const handleReset = () => {
      setSearchInput("")
      getAllClass(); 
    };

  return (
    <div className="class-manage-container">
      <div className="header">
        <h2>班级管理</h2>
        <div>
          <Input.Search
            placeholder="输入班级号搜索"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onSearch={handleSearch}
            enterButton
          />
        </div>
        <Button
          type="primary"
          onClick={handleReset}
        >
          重置
        </Button>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setIsModalVisible(true)}
        >
          添加班级
        </Button>
      </div>

      <Table
        dataSource={classes}
        rowKey="id"
        bordered
        pagination={{ pageSize: 7 }}
      >
        <Column title="班级名称" dataIndex="name" key="name" />
        <Column title="添加时间" dataIndex="createdAt" key="createdAt" />
        <Column
          title="操作"
          key="action"
          render={(_, record) => (
            <Space size="middle">
              <Button
                type="link"
                icon={<TeamOutlined />}
                onClick={() => getClassStudents(record.name)}
              >
                查看学生
              </Button>
              <Popconfirm
                title="确定要删除这个班级吗？"
                onConfirm={() => handleDeleteClass(record.id)}
                okText="确定"
                cancelText="取消"
              >
                <Button type="link" danger icon={<DeleteOutlined />}>
                  删除
                </Button>
              </Popconfirm>
            </Space>
          )}
        />
      </Table>

      {/* 添加班级模态框 */}
      <Modal
        title="添加班级"
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          form.resetFields();
        }}
        footer={null}
      >
        <Form form={form} onFinish={handleAddClass}>
          <Form.Item
            label="班级名称"
            name="name"
            rules={[{ required: true, message: "请输入班级名称" }]}
          >
            <Input placeholder="请输入班级名称" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              提交
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      {/* 查看学生名单模态框 */}
      <Modal
        title={`班级学生名单 (班级ID: ${currentClass})`}
        open={isStudentModalVisible}
        onCancel={() => setIsStudentModalVisible(false)}
        footer={null}
        width={900}
      >
        <Table
          dataSource={students}
          rowKey="id"
          bordered
          pagination={{
            ...pagination,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            onChange: (page, pageSize) => {
              setPagination({ current: page, pageSize });
            },
          }}
        >
          <Column
            title="学号"
            dataIndex="student_id"
            key="student_id"
            width={120}
          />
          <Column title="姓名" dataIndex="name" key="name" width={100} />
          <Column title="性别" dataIndex="sex" key="sex" width={60} />
          <Column title="学院" dataIndex="college" key="college" width={120} />
          <Column title="专业" dataIndex="major" key="major" width={120} />
          <Column
            title="入学日期"
            dataIndex="enrollment_date"
            key="enrollment_date"
            width={120}
            render={(date) => (date ? date.split("T")[0] : "无")}
          />
        </Table>
      </Modal>
    </div>
  );
};
